import React from 'react';
import { EM_DASH, formatSigned, isBlank } from './formatters';
import './ReportsNative.css';

/**
 * Signed variance chip with semantic tint (per financial-pnl.html cells).
 *
 * Positive = favorable (success tint) by default. Pass `invert` where a
 * positive variance is UNFAVORABLE (e.g. labor wages/hours over budget).
 * Null/undefined renders an untinted "—".
 *
 * Props:
 *   value     number | null
 *   format    format key or fn (default 'number'); the sign is added here
 *   currency  ISO code for currency formats
 *   invert    flip the semantic mapping (default false)
 *   title     hover tooltip
 */
export function VarianceChip({ value, format = 'number', currency, invert = false, className, title }) {
  if (isBlank(value)) {
    return <span className={`rn-mono rn-var rn-var-null${className ? ` ${className}` : ''}`}>{EM_DASH}</span>;
  }
  const n = Number(value);
  let tone = 'zero';
  if (n > 0) tone = invert ? 'neg' : 'pos';
  else if (n < 0) tone = invert ? 'pos' : 'neg';
  const text = formatSigned(n, format, currency ? { currency } : undefined);
  return (
    <span className={`rn-var rn-var-${tone}${className ? ` ${className}` : ''}`} title={title}>
      {text}
    </span>
  );
}

export default VarianceChip;
